<button routerLink="/" type="button" class="close d-lg-none" aria-label="Close">
  <span aria-hidden="true">&times;</span>
</button>
